import React, {useEffect, useState} from 'react';
import {useFormContext, Controller} from 'react-hook-form';
import Select from 'react-select';
import {useLocation} from 'react-router-dom';
import queryString from 'query-string';
import authHeader from '../../helpers/jwt-token-access/auth-token-header';
import axios from 'axios';
import {connect} from 'react-redux';
import {getPrinters} from '../../store/printers/actions';

const ListPrinters = ({data, filter, onChange, required = true, getPrinters}) => {
  const [printers, setPrinters] = useState([]);
  const [selectedPrinter, setSelectedPrinter] = useState(null);

  const {control, setValue} = useFormContext();
  const location = useLocation();
  const params = queryString.parse(location.search);

  useEffect(() => {
    if (params.id) {
      getPrinter(params.id);
    }
  }, [params.id]);

  useEffect(() => {
    getPrinters();
  }, [getPrinters]);

  useEffect(() => {
    if (data) {
      let filteredPrinters = data;
      if (filter) {
        filteredPrinters = filteredPrinters.filter((printer) =>
          filter.includes(printer.printer_type),
        );
      }

      setPrinters(
          filteredPrinters.map((printer) => ({
            ...printer,
            value: printer.id,
            label: printer.printer_serial_no,
          })),
      );
    }
  }, [data, filter]);

  const getPrinter = async (id) => {
    const url = `${process.env.REACT_APP_APIURL}printer/${id}`;
    const authToken = authHeader();

    try {
      const response = await axios.get(url, {headers: authToken});
      const printer = response.data.data;
      const selected = {...printer, value: printer.id, label: printer.printer_serial_no};
      setSelectedPrinter(selected);
      setValue('printer', selected);
      onChange && onChange(selected);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSelectPrinter = (printer) => {
    setSelectedPrinter(printer);
    setValue('printer', printer);
    onChange && onChange(printer);
  };

  return (
    <Controller
      name="printer"
      control={control}
      rules={{required}}
      render={({field, fieldState}) => (
        <div>
          <Select
            {...field}
            options={printers}
            value={selectedPrinter}
            onChange={(printer) => handleSelectPrinter(printer)}
            isClearable
          />
          {fieldState.error && <p className="text-danger"><small>Please choose a valid option.</small></p>}
        </div>
      )}
    />
  );
};

const mapStateToProps = (state) => {
  const {data} = state.Printers;
  return {data};
};

export default connect(mapStateToProps, {getPrinters})(ListPrinters);
